import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'classlist-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { StoreContext } from 'redux-react-hook';
import { addDynamicTestEnvironmentURLs } from 'config';
import { store } from 'redux/throttle';
import App from './app';
import * as serviceWorker from './serviceWorker';

window.eConsultFrontend = function (props) {
  const {
    treatmentCategoryCodeName,
    isClinicalReviewMode,
    newExperienceEnabled,
    federatedLoginProvider,
    logInStatus,
    TEST_CODE,
    practice,
    encounterId,
    healthAlertUrl,
    product,
    patient,
    dynamicTestEnvironmentURLs,
    twoWayMessageId,
    customisationFlags,
    showNavBar,
    backNav,
    currentQuestionId,
  } = props || {};
  addDynamicTestEnvironmentURLs(dynamicTestEnvironmentURLs);
  ReactDOM.render(
    <StoreContext.Provider value={store}>
      <App
        treatmentCategoryCodeName={treatmentCategoryCodeName}
        isClinicalReviewMode={isClinicalReviewMode}
        newExperienceEnabled={newExperienceEnabled}
        federatedLoginProvider={federatedLoginProvider}
        logInStatus={logInStatus}
        testCode={TEST_CODE}
        practice={practice}
        encounterId={encounterId}
        healthAlertUrl={healthAlertUrl}
        product={product}
        patient={patient}
        twoWayMessageId={twoWayMessageId}
        customisationFlags={customisationFlags}
        showNavBar={showNavBar}
        backNav={backNav}
        currentQuestionId={currentQuestionId}
      />
    </StoreContext.Provider>,
    document.getElementById('root'),
  );
};

export const eConsultFrontend = function (props) {
  const {
    treatmentCategoryCodeName,
    isClinicalReviewMode,
    newExperienceEnabled,
    federatedLoginProvider,
    logInStatus,
    TEST_CODE,
    practice,
    encounterId,
    healthAlertUrl,
    product,
    patient,
    dynamicTestEnvironmentURLs,
    twoWayMessageId,
    customisationFlags,
    showNavBar,
    backNav,
    currentQuestionId,
  } = props || {};
  addDynamicTestEnvironmentURLs(dynamicTestEnvironmentURLs);
  ReactDOM.render(
    <StoreContext.Provider value={store}>
      <App
        treatmentCategoryCodeName={treatmentCategoryCodeName}
        isClinicalReviewMode={isClinicalReviewMode}
        newExperienceEnabled={newExperienceEnabled}
        federatedLoginProvider={federatedLoginProvider}
        logInStatus={logInStatus}
        testCode={TEST_CODE}
        practice={practice}
        encounterId={encounterId}
        healthAlertUrl={healthAlertUrl}
        product={product}
        patient={patient}
        twoWayMessageId={twoWayMessageId}
        customisationFlags={customisationFlags}
        showNavBar={showNavBar}
        backNav={backNav}
        currentQuestionId={currentQuestionId}
      />
    </StoreContext.Provider>,
    document.getElementById('root'),
  );
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
